
import { defineComponent, onMounted, inject, ref, watch } from "vue";
import {
    getMountingsUnitTable,
    postEditMountingsUnit,
    postAddMountingsUnit,
    postDeleteMountingsUnit, permissionList,
} from "@/api/http";
import {Request} from '@/api/request';
export default defineComponent({
    name: "Company",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["配件单位"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([]),
            loading = ref(true),
            tableStatus = ref(["启用", "禁用"]),
            status = ref(-1),
            roleList = ref({} as any),
            search = ref(""),
            dialogFormVisible = ref(false),
            dialogTitle = ref("新增分类"),
            formRef = ref(null),
            form = ref({
                name: "",
                sort: 1,
                id: 0,
            }),
            isEdit = ref(false);
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'unit',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let data = {
                    page: currentPage.value,
                    pagesize: pageSize.value,
                };
                getMountingsUnitTable(data).then((res: any) => {
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                        loading.value = false;
                        total.value = res.content.count;
                    }
                });
            },
            columnChange = (item: any, type: boolean): void => {
                if (type) {
                    dialogTitle.value = "编辑分类";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    form.value.name = item.name;
                    form.value.sort = item.sort;
                    form.value.id = item.id;
                } else { // 启动禁止
                    // postDeleteMountingsUnit({ id: item.id }).then((res) =>
                    //     getTableData()
                    // );
					
					
                }
            },
			_upstatus = (id: number, status: number) => {
				Request.axiosInstance({
					url: 'adminapi/MountingsUnit/updStatus',
					data: {
						id: id,
						status: status
					}
				}).then((res: any) => {
					console.log(res)
					getTableData()
				})
			},
            submitForm = () => {
                (formRef.value as any).validate(async (valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            await postEditMountingsUnit(form.value).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        } else {
                            let data = {
                                name: form.value.name,
                                sort: form.value.sort,
                            };
                            await postAddMountingsUnit(data).then(
                                (res) =>
                                    (dialogFormVisible.value =
                                        res.status != 202)
                            );
                        }
                        !dialogFormVisible.value && getTableData();
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                (formRef.value as any).resetFields();
                form.value = {
                    name: "",
                    sort: 1,
                    id: 0,
                };
                isEdit.value = false;
                dialogTitle.value = "新增分类";
                (formRef.value as any).resetFields();
            }
        });

        return {
            headClass,
            pageSize,
            currentPage,
            total,
            tableData,
            tableStatus,
            loading,
            search,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            isEdit,
            handleSizeChange,
            handleCurrentChange,
            columnChange,
            submitForm,
			_upstatus,
            roleList
        };
    },
});
